<template>
    <!-- 数据表格 -->
    <el-card class="table-card" shadow="never">
        <div class="table-wrapper">
            <el-table :data="rows" v-loading="loading" style="width: 100%">
                <el-table-column label="ID" prop="id" width="200" />
                <el-table-column label="用户ID" prop="userId" width="200">
                    <template #default="scope">
                        <el-link underline="always" type="primary" @click="viewUser(scope.row.userId)">{{
                            scope.row.userId
                        }}</el-link>
                    </template>
                </el-table-column>
                <el-table-column label="卡包" prop="packName" width="200">
                    <template #default="scope">
                        <el-link underline="always" type="primary" @click="viewPack(scope.row.packId)">{{
                            scope.row.packName
                        }}</el-link>
                    </template>
                </el-table-column>
                <el-table-column label="抽卡次数" prop="count" width="120"></el-table-column>
                <el-table-column label="消费积分" prop="point" width="120">
                    <template #default="scope">
                        <el-text class="mx-1" type="danger">{{ scope.row.point }}</el-text>
                    </template>
                </el-table-column>
                <el-table-column label="获得卡片" prop="cards" width="150">
                    <template #default="scope">
                        <div class="draw-images">
                            <div v-for="([id, count], index) in Object.entries(scope.row.cards)" :key="id"
                                class="draw-image-item">
                                <el-badge :value="count" type="primary" :offset="[-15, 10]">
                                    <img :src="cardStore.cardsObj[id]?.image" loading="lazy" />
                                </el-badge>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="时间" prop="createdAt" width="200">
                    <template #default="scope">
                        {{ $formatTime(scope.row.createdAt) }}
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页 -->
        <div class="pagination-wrapper">
            <el-pagination v-model:current-page="filters.page" v-model:page-size="filters.size"
                :page-sizes="[10, 20, 50]" :total="filters.total" layout="total, sizes, prev, pager, next, jumper"
                @current-change="loadData" @size-change="loadData" />
        </div>
    </el-card>
</template>

<script setup>
import { ref, reactive, watch, onMounted } from "vue";
import { useRoute, useRouter } from 'vue-router';
import { apiCall } from "@/utils/api";
import { useCardStore } from "@/stores/card/card";

const cardStore = useCardStore();

const route = useRoute();
const router = useRouter();

const loading = ref(false);

const rows = ref([]);

const filters = reactive({
    page: Number(route.query.page) || 1,
    size: Number(route.query.size) || 20,
    total: 0,
});

watch(
    filters,
    (val) => {
        router.replace({ query: { ...val } });
    },
    { deep: true }
);

async function loadData() {
    loading.value = true;

    const params = {
        page: filters.page || 1,
        size: filters.size || 20,
    };

    const response = await apiCall("user.getUserDrawLogs", params);
    if (!response) {
        return false;
    }
    filters.total = response.count;
    rows.value = response.rows;

    loading.value = false;
}

function viewUser(id) {
    router.push(`/user/${id}`);
}

function viewPack(id) {
    router.push(`/pack/${id}`);
}

onMounted(async () => {
    await cardStore.getAll();
    await loadData();
});
</script>

<style scoped>
.draw-images {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(60px, 1fr));
    gap: 2px;
    padding: 2px;
}

.draw-image-item {
    position: relative;
    width: 60px;
    aspect-ratio: 3 / 4;
    overflow: hidden;
    border-radius: 8px;
    background: #f6f6f6;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.draw-image-item:hover {
    transform: scale(1.03);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.draw-image-item img {
    width: 60px;
    aspect-ratio: 3 / 4;
    object-fit: cover;
    cursor: pointer;
    transition: 0.3s ease;
}
</style>
